import React, { useEffect, useState } from "react";
import Switch from "react-switch";
import utils from "../../../Utils";
import "./clinicTiming.css";
import ReactInputMask from "react-input-mask";
import toast from "react-hot-toast";
import Widgets from "../../../Widgets";
import { t } from "../../../Utils/translate";

function ClinicTiming({ setPage, isEditTiming, closeTiming, isEdited, clinicTimings, onClinicTimingsChange }) {
  const inputTypeFrom = "FROM";
  const inputTypeTo = "TO";
  const [dayList, setDayList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditTimingValue, setIsEditTimingValue] = useState(null);

  useEffect(() => {
    setUpDayList();
  }, [clinicTimings]);

  useEffect(() => {
    setIsEditTimingValue(isEditTiming ? true : false);
  }, [isEditTiming]);

  async function setUpDayList() {
    const emptyDayList = [
      { day: "Monday", displayDay: t("Monday"), status: false, limit: 3, timing: [] },
      { day: "Tuesday", displayDay: t("Tuesday"), status: false, limit: 3, timing: [] },
      { day: "Wednesday", displayDay: t("Wednesday"), status: false, limit: 3, timing: [] },
      { day: "Thursday", displayDay: t("Thursday"), status: false, limit: 3, timing: [] },
      { day: "Friday", displayDay: t("Friday"), status: false, limit: 3, timing: [] },
      { day: "Saturday", displayDay: t("Saturday"), status: false, limit: 3, timing: [] },
      { day: "Sunday", displayDay: t("Sunday"), status: false, limit: 3, timing: [] },
    ];

    const mergedDayList = emptyDayList.map((day) => {
      const timingData = clinicTimings.find((timing) => timing.dayOfWeek === day.day);
      if (timingData && timingData.opens && timingData.closes) {
        day.status = true;
        day.timing = [{ from: timingData.opens, to: timingData.closes }];
      }
      return day;
    });

    setDayList(mergedDayList);
  }

  const convertToOpeningHoursSpecification = (openingHours) => {
    const openingHoursSpecification = openingHours.map(({ day, timing }) => ({
      dayOfWeek: day,
      opens: timing.length > 0 ? timing[0].from : null,
      closes: timing.length > 0 ? timing[0].to : null,
    }));
    onClinicTimingsChange(openingHoursSpecification);
  };

  function onCollisionCheck(inputType, value, item, timeArrIndex, dayArrIndex) {
    let dayListArr = [...dayList];
    let arr = [...item.timing];

    let res = utils.utilFunctions.checkClinicTimeCollission(arr, timeArrIndex);
    if (!res) {
      toast.dismiss();
      toast.error(t("invalidTimeOrSlot"));
      if (inputType == inputTypeFrom) {
        arr[timeArrIndex] = {
          from: "__:__",
          to: arr[timeArrIndex].to,
        };
      } else if (inputType == inputTypeTo) {
        arr[timeArrIndex] = {
          from: arr[timeArrIndex].from,
          to: "__:__",
        };
      }
      dayListArr[dayArrIndex].timing = arr;
      setDayList(dayListArr);
    } else {
      convertToOpeningHoursSpecification(dayListArr);
    }
  }

  function setInputValue(inputType, value, item, timeArrIndex, dayArrIndex) {
    let dayListArr = [...dayList];
    let arr = [...item.timing];
    if (inputType == inputTypeFrom) {
      arr[timeArrIndex] = {
        from: value,
        to: arr[timeArrIndex].to,
      };
    } else if (inputType == inputTypeTo) {
      arr[timeArrIndex] = {
        from: arr[timeArrIndex].from,
        to: value,
      };
    }
    dayListArr[dayArrIndex].timing = arr;
    setDayList(dayListArr);
  }

  if (isEditTimingValue != null) {
    return (
      <div>
        {isLoading ? <Widgets.CircularLoader /> : null}
        <div className="clinic-timing-item-container">
          {dayList.map((item, i) => (
            <div key={i} className="clinic-timing-item-view">
              <div className="clinic-timing-boxes d-flex justify-content-between">
                <span className="week-names">{item.displayDay}</span>
                <Switch
                  onChange={() => {
                    let arr = [...dayList];
                    arr[i].status = !arr[i].status;

                    if (arr[i].status) {
                      // Enable day and add default time if empty
                      if (i === 0 && arr[i].timing.length === 0) {
                        arr[i].timing.push(utils.constants.timeValue);
                      } else if (dayList[0].status) {
                        arr[i].timing = dayList[0].timing;
                      } else if (arr[i].timing.length === 0) {
                        arr[i].timing.push(utils.constants.timeValue);
                      }
                    } else {
                      // Disable day and clear timing
                      arr[i].timing = [];
                    }

                    setDayList(arr);
                    convertToOpeningHoursSpecification(arr); // Update clinic timings on every toggle
                  }}
                  checked={item.status}
                  uncheckedIcon={utils.appStyles.switchStyle.uncheckedIcon}
                  checkedIcon={utils.appStyles.switchStyle.checkedIcon}
                  handleDiameter={utils.appStyles.switchStyle.handleDiameter}
                  height={utils.appStyles.switchStyle.height}
                  width={utils.appStyles.switchStyle.width}
                  offHandleColor={utils.appStyles.switchStyle.offHandleColor}
                  onHandleColor={utils.appStyles.switchStyle.onHandleColor}
                  offColor={utils.appStyles.switchStyle.offColor}
                  onColor={utils.appStyles.switchStyle.onColor}
                  activeBoxShadow={utils.appStyles.switchStyle.activeBoxShadow}
                />
              </div>

              {item.status &&
                item.timing.map((item2, i2) => {
                  let fromValue = item2.from;
                  let toValue = item2.to;

                  return (
                    <div key={i2} className="clinic-timing-boxes-2-parent">
                      <div className="clinic-timing-boxes-2 d-flex">
                        <div className="clinic-timing-boxes-2-input-view">
                          <div className="clinic-timing-range-label">{t("btnFrom")}</div>
                          <ReactInputMask
                            placeholder={t("hh_mm")}
                            mask={"99:99"}
                            value={fromValue}
                            onChange={(e) => setInputValue(inputTypeFrom, e.target.value, item, i2, i)}
                            onBlur={(e) => onCollisionCheck(inputTypeFrom, e.target.value, item, i2, i)}
                            className="form-control time-input"
                          />
                        </div>
                        <div className="clinic-timing-boxes-2-input-view">
                          <div className="clinic-timing-range-label">{t("btnTo")}</div>
                          <ReactInputMask
                            placeholder={t("hh_mm")}
                            mask={"99:99"}
                            value={toValue}
                            onChange={(e) => setInputValue(inputTypeTo, e.target.value, item, i2, i)}
                            onBlur={(e) => onCollisionCheck(inputTypeTo, e.target.value, item, i2, i)}
                            className="form-control time-input"
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          ))}
        </div>
      </div>
    );
  }
  return null;
}

export default ClinicTiming;
